<template>
  <hb-basic-page fill-height :loading="loading" hide-app-bar>
    <v-row no-gutters align="center" class="fill-height" no-gutters>
      <v-col class="login-holder px-xl-16" cols="12" lg="4" md="6" offset-lg="4" offset-md="3" offset-xl="4" xl="4">
        <div class="text-center pb-2">
          <a :alt="$t('title')" href="https://ekd.fi/" target="_blank">
            <img :alt="$t('title')" :style="{width: $vuetify.breakpoint.smAndDown ? '50%' : '60%'}"
                 src="/img/EKD-logo-white.png" style="height: auto;"/>
          </a>
        </div>

        <div :class="$vuetify.breakpoint.xl?'text-weight-bold':''"
             class="headline grey--text text--darken-1 text-center mb-12 mt-4">{{ $t('slogan') }}
        </div>


        <div class="login-guide text-center grey--text text--darken-1 body-1 my-5">
          <div class="text-center body-1">
            <div :style="{fontSize: $vuetify.breakpoint.xsOnly ? '15px' : ''}"
                 class="text-center font-weight-regular">
              {{ $t('login.multiple_tenants') }}
            </div>
          </div>
        </div>
        <v-list v-if="user && user.tenants && user.tenants.length > 0" class="py-0">
          <template v-for="(tenant, index) in user.tenants">
            <v-list-item :key="tenant.id" @click="tenantSelect(tenant.id)">
              <v-list-item-title>{{ tenant.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index < user.tenants.length - 1" :key="`${tenant.id}_divider`"></v-divider>
          </template>
        </v-list>
        <div class="login-guide text-center grey--text text--darken-1 body-1 my-5">
          <div class="text-center body-1">
            <div :style="{fontSize: $vuetify.breakpoint.xsOnly ? '15px' : ''}"
                 class="text-center font-weight-regular">
              {{ $t('login.multiple_tenants_2') }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </hb-basic-page>
</template>

<script>
import UserService from '../service/user.service';
import tenantService from "@/service/tenant.service";

export default {
  name: 'RedirectToTenantStartView',
  data() {
    return {
      loading: true,
      user: null,
    }
  },
  methods: {
    tenantSelect(tenantId) {
      tenantService.setTenant(tenantId);
      this.$store.commit('setLoadingOverlay', true);
      this.$router.replace({name: 'tenant_start', params: {tenantId: tenantId}});
    }
  },
  async mounted() {
    const user = await UserService.getUserInfo();
    if (user.tenants?.length > 1) {
      this.user = user;
      this.loading = false;
    } else {
      if (this.$isLoggedIn && !this.$tenant && !this.$isAdmin) {
        this.$router.push({name: 'new_account'})
      } else if (this.$isLoggedIn && this.$tenant != null) {
        this.$router.push({name: 'tenant_start', params: {tenantId: this.$tenant}});
      } else if (this.$isLoggedIn && this.$tenant == null && this.$isAdmin) {
        this.$router.push({name: 'tenants'});
      }
    }
  },
};
</script>

<style scoped></style>
